import { api } from '../configs/axiosConfigs';

export const fetchFavorites = async () => {
  return await api.get('/favorites.json');
};
